import React from 'react';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { FilterConfiguration } from './settings/FilterConfiguration';
import { General } from './settings/General';
import { EngagementPlan } from './settings/EngagementPlan';
import { Billing } from './settings/Billing';
import { SettingsIcon, FilterIcon, BellIcon, UsersIcon, PlugIcon, ClipboardListIcon, CreditCardIcon } from 'lucide-react';
export function Settings() {
  const location = useLocation();
  const settingsMenuItems = [{
    path: '/settings',
    label: 'General',
    icon: SettingsIcon,
    exact: true
  }, {
    path: '/settings/billing',
    label: 'Billing & Subscription',
    icon: CreditCardIcon
  }, {
    path: '/settings/engagement-plan',
    label: 'Engagement Plan',
    icon: ClipboardListIcon
  }, {
    path: '/settings/filters',
    label: 'Filter Configuration',
    icon: FilterIcon
  }, {
    path: '/settings/notifications',
    label: 'Notifications',
    icon: BellIcon
  }, {
    path: '/settings/users',
    label: 'User Management',
    icon: UsersIcon
  }, {
    path: '/settings/integrations',
    label: 'Integrations',
    icon: PlugIcon
  }];
  const isActive = (path: string, exact?: boolean) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-2438">
      <Sidebar data-id="element-2439" />
      <main className="flex-1" data-id="element-2440">
        <Header data-id="element-2441" />
        <div className="flex h-[calc(100vh-73px)]" data-id="element-2442">
          {/* Settings Sidebar */}
          <div className="w-64 bg-white border-r border-gray-200 p-4" data-id="element-2443">
            <h2 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-4 px-3" data-id="element-2444">
              Settings
            </h2>
            <nav className="space-y-1" data-id="element-2445">
              {settingsMenuItems.map(item => {
              const Icon = item.icon;
              const active = isActive(item.path, item.exact);
              return <Link key={item.path} to={item.path} className={`flex items-center px-3 py-2 rounded-md text-sm transition-colors ${active ? 'bg-blue-50 text-blue-600 font-medium' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-2446">
                    <Icon size={18} className="mr-3" data-id="element-2447" />
                    {item.label}
                  </Link>;
            })}
            </nav>
          </div>

          {/* Settings Content */}
          <div className="flex-1 overflow-y-auto p-8" data-id="element-2448">
            <Routes data-id="element-2449">
              <Route path="/" element={<General data-id="element-2451" />} data-id="element-2450" />
              <Route path="/billing" element={<Billing data-id="element-2453" />} data-id="element-2452" />
              <Route path="/engagement-plan" element={<EngagementPlan data-id="element-2455" />} data-id="element-2454" />
              <Route path="/filters" element={<FilterConfiguration data-id="element-2457" />} data-id="element-2456" />
              <Route path="/notifications" element={<NotificationsPlaceholder data-id="element-2459" />} data-id="element-2458" />
              <Route path="/users" element={<UsersPlaceholder data-id="element-2461" />} data-id="element-2460" />
              <Route path="/integrations" element={<IntegrationsPlaceholder data-id="element-2463" />} data-id="element-2462" />
            </Routes>
          </div>
        </div>
      </main>
    </div>;
}
function NotificationsPlaceholder() {
  return <div data-id="element-2464">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-2465">
        Notifications
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-2466">
        Configure your notification preferences
      </p>
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2467">
        <p className="text-gray-500" data-id="element-2468">Notification settings coming soon...</p>
      </div>
    </div>;
}
function UsersPlaceholder() {
  return <div data-id="element-2469">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-2470">
        User Management
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-2471">Manage team members and permissions</p>
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2472">
        <p className="text-gray-500" data-id="element-2473">User management coming soon...</p>
      </div>
    </div>;
}
function IntegrationsPlaceholder() {
  return <div data-id="element-2474">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-2475">
        Integrations
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-2476">
        Connect third-party services and APIs
      </p>
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2477">
        <p className="text-gray-500" data-id="element-2478">Integration settings coming soon...</p>
      </div>
    </div>;
}